<button class="closeButton" mat-raised-button color="primary" (click)="close()"> {{'close' | translation}}</button>

<main>
  <div>
    <img [src]="data.mediaSource"/>
  </div>
</main>
